<template>
  <div class="preloader">
    <img src="../assets/loader.gif" alt="Preloader Icon" />
    <div class="progress">
      <div class="progress-bar" :style="{ width: percent + '%' }"></div>
    </div>
    <p>Setting up the configurator: {{ percent }}%</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { generate_map_link } from '@/lib/helpers';

export default {
  name: 'Preloader',
  data: function() {
    return {
      percent: 0,
    };
  },
  computed: {
    ...mapGetters(['configurator']),
    preload_length() {
      return this.configurator.configs.reduce((acc, val) => {
        return acc + val.material.length;
      }, 0);
    },
  },
  mounted: function() {
    this.preload();
  },
  methods: {
    preload() {
      if (!this.configurator.name) return false;

      let loaded = 0;

      this.$nextTick(() => {
        this.configurator.configs.forEach(item => {
          item.material.forEach(material => {
            const link = generate_map_link(
              this.configurator.name,
              item.name,
              material.name
            );
            const img = new Image();
            img.src = link;
            img.onload = () => {
              loaded++;
              this.percent = Math.round((loaded / this.preload_length) * 100);
              if (this.percent === 100) {
                setTimeout(
                  () => this.$store.commit('SET_APP_PRELOADED', true),
                  2000
                );
              }
            };
            img.onerror = () => {
              loaded++;
            };
          });
        });
      });
    },
  },
};
</script>
